<template>
  <div id="app" class="fade-in">
  <!-- video modal window portal -->
    <portal-target
      name="modal-window"
      slim/>
    <app-navbar/>
    <app-jumbotron :imgPath="'./static/images/touchstands-bg-02--3x2--1920.jpg'">
      <p
        slot="subtitle"
        class="TitleCard-subtitle">
        Adjustable Multitouch Tables
      </p>
      <h2
        slot="title"
        class="TitleCard-title dotGrid dotGrid--white dotGrid--jumbotron">
        Touch Displays &amp; Motorized Stands
      </h2>
      
    </app-jumbotron>
    <app-v-modal />
    <app-card/>
    <app-about/>
    <app-spec/>
    <app-aside/>
    <app-clients/>
    <app-contact/>
  </div>
</template>

<script>
import Rellax from 'rellax'
import emergence from 'emergence.js'

import appAbout from './components/About'
import appAside from './components/Aside'
import appCard from './components/Card'
import appClients from './components/Clients'
import appContact from './components/Contact'
import appJumbotron from './components/Jumbotron'
import appVButton from './components/VButton'
import appVModal from './components/VModal'
import appNavbar from './components/Navbar'
import appSpec from './components/Spec'

require('lazysizes')

export default {
  name: 'app',

  components: {
    appAbout,
    appAside,
    appCard,
    appClients,
    appContact,
    appJumbotron,
    appVButton,
    appVModal,
    appNavbar,
    appSpec
  },

  mounted () {
    const rellax = new Rellax('.rellax', { speed: -1 })
    console.log(rellax)
    emergence.init({
      reset: false
    })
  }
}
</script>

<style lang="scss" scoped>
@import './assets/styles/_variables.scss';

#app {
  overflow: hidden;
}

.dotGrid--jumbotron {
  &::before{
  top: -43%;
  left: -10%;
  width: 85%;
  height: 175%;
  }
}
</style>




// WEBPACK FOOTER //
// src/App.vue